<template>
    <pop-form :state="show" width="580px" body-max-height="480px">
        <template slot="title">组合支付 <i class="el-icon-close close" @click="close"></i></template>
        <div class="body-box">
            <div class="joint-box">
                <div class="actual-box">
                    实收 <span class="red">¥ {{actualPrice}}</span>
                </div>
                <div class="pay-list">
                    <div class="pay-item" v-if="this.userInfo.store_uid">
                        <div class="label">余额</div>
                        <div class="value"><el-input v-model="formData.money" placeholder="" @change="formChange" /></div>
                    </div>
                    <div class="pay-item">
                        <div class="label">微信</div>
                        <div class="value"><el-input v-model="formData.wechat" placeholder="" @change="formChange" /></div>
                    </div>
                    <div class="pay-item">
                        <div class="label">支付宝</div>
                        <div class="value"><el-input v-model="formData.alipay" placeholder="" @change="formChange" /></div>
                    </div>
                    <div class="pay-item">
                        <div class="label">现金</div>
                        <div class="value"><el-input v-model="formData.cash" placeholder="" @change="formChange" /></div>
                    </div>
                    <div class="pay-item">
                        <div class="label">银联卡</div>
                        <div class="value"><el-input v-model="formData.unionpay" placeholder="" @change="formChange" /></div>
                    </div>
                    <div class="pay-item" v-if="this.userInfo.store_uid">
                        <div class="label">欠款</div>
                        <div class="value"><el-input v-model="formData.arrears" placeholder="" @change="formChange" /></div>
                    </div>
                </div>
            </div>
            <div class="sur-pay" v-if="surPrice < 0">
                还需支付<span class="red"> - ¥{{Math.abs(surPrice).toFixed(2)}}</span>
            </div>
            <div class="sur-pay" v-else>
                还需支付<span class="red"> ¥{{Math.abs(surPrice).toFixed(2)}}</span>
            </div>
            <!--<div class="sur-pay" v-else>-->
                <!--<span class="red">付款金额超出了待支付金额</span>-->
            <!--</div>-->
        </div>
        <template v-slot:foot>
            <div class="foot-box">
                <el-button size="medium" @click="close">&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>
                <el-button size="medium" type="primary" @click="submit">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
            </div>
        </template>
    </pop-form>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "CashJointPay",
        components: {PopForm},
        model: {
            prop: "show",
            event: "showChange"
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            userInfo: {
                type: Object,
                default: () => {}
            },
            actualPrice: {
                type: [Number, String],
                default: 0
            },
            payData: {
                type: Object,
                default: () => {}
            }
        },
        data(){
            return {
                formData: {
                    money: 0,       //余额
                    wechat: 0,      //微信
                    alipay: 0,      //支付宝
                    cash: 0,        //现金
                    unionpay: 0,     //银联
                    arrears: 0      //欠款
                },
                surPrice: 0,
            };
        },
        methods: {
            //初始化
            init(){
                if(!obj.isEmpty(this.payData)) {
                    this.formData = this.payData;
                }else{
                    this.formData = {
                        money: 0,       //余额
                        wechat: 0,      //微信
                        alipay: 0,      //支付宝
                        cash: 0,        //现金
                        unionpay: 0,    //银联
                        arrears: 0      //欠款
                    };
                }
                if (this.userInfo.store_uid) {
                    this.formData.money = parseFloat(this.userInfo.money) > this.actualPrice ?
                        this.actualPrice : parseFloat(this.userInfo.money);
                }else{
                    this.formData.money = 0;
                }
                this.formData.arrears = 0;
                this.formChange();

            },
            //关闭
            close(){
                this.$emit("showChange", false);
            },
            //确定
            submit(){
                //判断组合支付数据中是否有负数和非数字字符
                for (let key in this.formData) {
                    let num = Number(this.formData[key]);
                    if(isNaN(num) || num < 0) {
                        this.$message.error("支付金额填写错误");
                        return false;
                    }
                }

                //判断金额是否与实收相符
                if(this.surPrice > 0) {
                    this.$message.error("支付金额与实收金额不符");
                    return false;
                }else if(this.surPrice < 0){
                    this.$message.error("支付金额与实收金额不符");
                    return false;
                }

                this.$emit("submit", this.formData);
                this.close();
            },
            //组合付款值改变
            formChange(){
                let surPrice =  this.actualPrice - this.formData.money - this.formData.wechat - this.formData.alipay -
                                this.formData.cash - this.formData.unionpay - this.formData.arrears;
                this.surPrice = Math.round(surPrice * 100)/100;
            }
        },
        watch: {
            show(val){
                if(val) this.init();
            }
        }
    }
</script>

<style scoped>
    .close{
        float: right;
        color: #9095a6;
    }
    .foot-box{
        padding: 0 20px 10px;
        text-align: right;
    }
    .body-box{
        padding: 0 13px;
    }
    .joint-box{
        padding: 15px 15px 15px 0;
    }
    .joint-box>.actual-box{
        margin: 5px 0 30px 16px;
    }
    .sur-pay{
        text-align: right;
        margin-top: 70px;
    }

    .pay-list{
        display: flex;
        flex-flow: row wrap;
    }
    .pay-list>.pay-item{
        display: flex;
        width: 33.33%;
        margin-bottom: 16px;
    }
    .pay-item>.label{
        width: 45px;
        margin-right: 14px;
        text-align: right;
        line-height: 40px;
    }
    .pay-item>.value{
        width: 100px;
        height: 40px;
        margin-right: 12px;
    }
</style>
